import { ArrowLeft, Info } from 'lucide-react'
import { useState } from 'react'

import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { TransferData } from '@/types/payment'

interface EmailRecipientScreenProps {
  transferData: TransferData
  onNext: () => void
  onBack: () => void
}

const EmailRecipientScreen = ({
  transferData,
  onNext,
  onBack,
}: EmailRecipientScreenProps) => {
  const [email, setEmail] = useState('')
  const [fullName, setFullName] = useState('')

  const isFormValid = email.trim() !== '' && fullName.trim() !== ''

  return (
    <div className="p-6 space-y-6">
      {/* Logo */}
      <div className="flex justify-center mb-6">
        <img src="/paytrie-logo.png" alt="Paytrie" className="h-8 w-auto" />
      </div>

      {/* Header */}
      <div className="text-center space-y-2">
        <h1 className="text-2xl font-bold text-gray-900">
          Enter their account details
        </h1>
      </div>

      {/* Email Field */}
      <div className="space-y-2">
        <label htmlFor="email" className="block text-gray-900 font-medium">
          Their email
        </label>
        <Input
          id="email"
          type="email"
          placeholder="example@example.ex"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full"
        />
      </div>

      {/* Info Box */}
      <div className="bg-gray-100 rounded-xl p-4 space-y-3">
        <div className="flex items-start space-x-3">
          <div className="w-6 h-6 bg-gray-800 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
            <Info className="w-4 h-4 text-white" />
          </div>
          <p className="text-gray-700 text-sm leading-relaxed">
            We'll send your recipient an email to request their bank details
            once you've completed the transfer. Make sure they respond to our
            email or the money will be refunded to you.
          </p>
        </div>
      </div>

      {/* Bank Details Section */}
      <div className="space-y-4">
        <h2 className="text-xl font-bold text-gray-900">
          Recipient's bank details
        </h2>

        <div className="space-y-2">
          <label htmlFor="fullName" className="block text-gray-900 font-medium">
            Full name of the account holder
          </label>
          <Input
            id="fullName"
            type="text"
            placeholder=""
            value={fullName}
            onChange={(e) => setFullName(e.target.value)}
            className="w-full"
          />
        </div>
      </div>

      {/* Buttons */}
      <div className="flex space-x-4 pt-4">
        <Button
          variant="outline"
          onClick={onBack}
          className="flex-1 flex items-center justify-center space-x-2 text-gray-700 hover:text-gray-900 border border-gray-300 hover:bg-yellow-50 hover:border-yellow-200 transition-colors"
        >
          <ArrowLeft className="w-4 h-4" />
          <span>Back</span>
        </Button>

        <Button
          onClick={onNext}
          disabled={!isFormValid}
          className={`flex-1 font-medium transition-colors ${
            isFormValid
              ? 'bg-black text-white hover:bg-gray-800'
              : 'bg-gray-300 text-gray-500 cursor-not-allowed'
          }`}
        >
          Continue
        </Button>
      </div>
    </div>
  )
}

export default EmailRecipientScreen
